import { Link } from "react-router-dom";
import type { RankItem } from "@/types/content";
import { formatHeat } from "@/utils/format";

interface RankPodiumProps {
  items: RankItem[];
}

const podiumStyle = [
  {
    wrap: "border-primary-200 bg-primary-50",
    badge: "bg-primary-500 text-background-50",
    label: "榜首",
  },
  {
    wrap: "border-accent-300/70 bg-accent-50",
    badge: "bg-accent-500 text-accent-950",
    label: "第二",
  },
  {
    wrap: "border-secondary-200 bg-secondary-50",
    badge: "bg-secondary-500 text-background-50",
    label: "第三",
  },
];

export default function RankPodium({ items }: RankPodiumProps) {
  const podium = items.slice(0, 3);

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {podium.map((item, index) => {
        const style = podiumStyle[index];
        return (
          <Link
            key={item.slug}
            to={`/article/${item.slug}`}
            className={`group flex flex-col justify-between rounded-card border p-5 transition-colors duration-200 hover:border-primary-300 ${style.wrap}`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${style.badge}`}
              >
                <span className="flex h-3 w-3 items-center justify-center">
                  <i className="ri-trophy-line text-[12px]"></i>
                </span>
                {style.label}
              </span>
              <span className="font-heading text-3xl font-black text-foreground-200">
                {item.rank}
              </span>
            </div>
            <h3 className="mt-5 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700">
              {item.title}
            </h3>
            <div className="mt-4 flex items-center justify-between border-t border-background-300/50 pt-3 text-xs">
              <span className="rounded-full bg-background-50 px-2 py-0.5 text-foreground-600">
                {item.category}
              </span>
              <span className="flex items-center gap-1 font-medium text-foreground-700">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-fire-line text-[12px] text-primary-500"></i>
                </span>
                {formatHeat(item.heat)}
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}